<template>
  <div class="chart-box">
    <Loading v-if="loading" />
    <component
      :is="chartConfig.chartType"
      :item="chartConfig"
      :index="index"
      :intervalTime="intervalTime"
      :data="chartSource"
      :childSource="childSource"
      :type="type"
      :childQuery="headerValue"
      v-else
    ></component>
    <!-- :childQuery="headerValue" -->
  </div>
</template>
<script>
import charts from '@/components/charts/index';
import { mapActions, mapGetters, mapState } from 'vuex';
import { QueryTypes } from '@/components/Common/constant';
import { CalculationType } from '@/components/charts/constant';
import dayjs from 'dayjs';
import Loading from '@/rex-components/rex-loading.vue';
import {
  CAPABILITY_BROWSER,
  CAPABILITY_MOBILE,
  CAPABILITY_APM,
} from '@/utils/constants';
import { GetConstantValues } from '@/utils/metrics-constants/mapper';
export default {
  name: 'GraphBuilder',
  components: { ...charts, Loading },
  data: function () {
    return {
      type: undefined,
      itemConfig: {},
      chartSource: {},
      childSource: [],
      headerValue: {},
      dialogConfigVisible: false,
      height: '200',
      pageTypes: ['TOPOLOGY_ENDPOINT', 'TOPOLOGY_INSTANCE'],
      loading: true,
    };
  },
  props: {
    chartConfig: {},
    index: {},
    home: {},
    layoutIndex: {},
  },
  computed: {
    ...mapState('globalState/app', ['updateDashboard']),
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
    ...mapState('globalState/app', ['updateDashboard', 'currentCapability']),
    getHeight() {
      if (this.chartConfig.chartType === 'ChartNum') {
        return '3.75rem';
      } else return '8.4375rem';
    },
  },

  methods: {
    ...mapActions('homeState', { getGraphDataAction: 'getGraphData' }),

    async chartRender() {
      try {
        this.loading = true;
        await this.getGraphDataAction({
          duration: this.getDurationTime,
          index: this.index,
          type: this.type,
          layoutIndex: this.layoutIndex,
          children: { present: false, childIndex: 0 },
          dashboardType: {
            type: this.chartConfig.entityType,
            isDatabase: this.chartConfig.isDatabase,
          },
          chartConfig: this.chartConfig,
        })
          //params are of type : Array<{ metricName: string; [key: string]: any; config: any }>
          .then(async (params) => {
            if (!params) {
              return;
            }

            if (!params.length) {
              return;
            }
            this.itemConfig = params[0].config;
            const { queryMetricType, chartType } = this.itemConfig;
            let data = params;
            if (
              queryMetricType ===
              QueryTypes.ReadMetricsValue /*&& chartType === 'ChartSlow'*/
            ) {
              const arr = [
                {
                  config: this.itemConfig,
                  [QueryTypes.ReadMetricsValue]: params.map((item, index) => {
                    return {
                      id: index,
                      name: item.metricName,
                      value: item[QueryTypes.ReadMetricsValue],
                    };
                  }),
                },
              ];

              data = arr;
            } else if (
              queryMetricType !== QueryTypes.ReadMetricsValues ||
              queryMetricType === QueryTypes.ReadCustomMetricsValues
            ) {
              if (
                (this.currentCapability === CAPABILITY_BROWSER ||
                  this.currentCapability === CAPABILITY_MOBILE ||
                  this.currentCapability === CAPABILITY_APM) &&
                params.length > 1
              ) {
                data = params;
              } else {
                data = [params[0]];
              }
            }
            await this.chartValue(data);
            if (this.itemConfig.childQueries) {
              this.childSource = [];
              // this.getChildQueries(this.chartConfig.childQueries, this.index);
            }
          })
          .catch((error) => {
            console.log('GET_QUERY failed ' + error.message);
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        console.log('error', error);
      }
    },
    getChildQueries(childQueries, parentIndex) {
      childQueries.forEach((item, childIndex) => {
        this.getGraphDataAction({
          duration: this.getDurationTime,
          index: parentIndex,
          type: this.type,
          layoutIndex: this.layoutIndex,
          children: { present: true, childIndex: childIndex },
          dashboardType: {
            type: item.entityType,
            isDatabase: this.chartConfig.isDatabase,
          },
        })
          //params are of type : Array<{ metricName: string; [key: string]: any; config: any }>
          .then((params) => {
            if (!params) {
              return;
            }

            if (!params.length) {
              return;
            }
            this.itemConfig = params[0].config;
            const { queryMetricType, chartType } = this.itemConfig;
            let data = params;
            if (
              queryMetricType ===
              QueryTypes.ReadMetricsValue /*&& chartType === 'ChartSlow'*/
            ) {
              const arr = [
                {
                  config: this.itemConfig,
                  [QueryTypes.ReadMetricsValue]: params.map((item, index) => {
                    return {
                      id: index,
                      name: item.metricName,
                      value: item[QueryTypes.ReadMetricsValue],
                    };
                  }),
                },
              ];
              data = arr;
            } else if (queryMetricType !== QueryTypes.ReadMetricsValues) {
              data = [params[0]];
            }
            this.childQueryValue(data, item.name);
            // this.loading = false;
          })
          .catch((error) => {
            console.log('GET_QUERY failed ' + error.message);
          });
      });
    },
    // params type : Array<{ metricName: string; [key: string]: any; config: any }>
    chartValue(data) {
      this.chartSource = {};
      for (const params of data) {
        const {
          queryMetricType,
          aggregation,
          aggregationNum,
          metricLabels,
          labelsIndex,
          chartType,
          metricName,
        } = params.config;
        const resVal = params[queryMetricType];
        if (queryMetricType === QueryTypes.ReadMetricsValue) {
          if (chartType === 'ChartSlow') {
            this.handleChartSlowData(
              resVal,
              aggregation,
              aggregationNum,
              metricName,
            );
          } else {
            this.chartSource = (resVal || []).map((item) => {
              return {
                name: item.name,
                avgNum: [
                  CalculationType[4].value,
                  CalculationType[5].value,
                ].includes(aggregation)
                  ? this.formatDate({
                      data: item.value,
                      type: aggregation,
                      aggregationNum,
                    })
                  : this.aggregationValue({
                      data: item.value,
                      type: aggregation,
                      aggregationNum: Number(aggregationNum),
                    }),
              };
            });
          }
        }
        // if (queryMetricType === QueryTypes.ReadMetricsValues) {
        if (
          queryMetricType === QueryTypes.ReadMetricsValues ||
          queryMetricType === QueryTypes.ReadCustomMetricsValues
        ) {
          if (!(resVal && resVal.values)) {
            this.chartSource[params.metricName] = [];
            return;
          }
          if (resVal.values) {
            this.headerValue = {
              avg: resVal.avg,
              total: resVal.total,
              perMin: resVal.perMin,
            };
          }
          const { values } = resVal.values;

          this.chartSource[params.metricName] = values.map((item) =>
            this.aggregationValue({
              data: item.value,
              type: aggregation,
              aggregationNum: Number(aggregationNum),
            }),
          );
          let seriesKey = GetConstantValues.prototype.getValueByConstantName(
            params.metricName,
          );
          if (seriesKey) {
            this.chartSource[seriesKey] = this.chartSource[params.metricName];
            delete this.chartSource[params.metricName];
          }
        }
        if (
          queryMetricType === QueryTypes.SortMetrics ||
          queryMetricType === QueryTypes.ReadSampledRecords
        ) {
          this.handleChartSlowData(
            resVal,
            aggregation,
            aggregationNum,
            metricName,
          );
        }
        if (queryMetricType === QueryTypes.READHEATMAP) {
          const nodes = [];
          if (!(resVal && resVal.values)) {
            this.chartSource = { nodes: [] };
            return;
          }
          resVal.values.forEach((items, x) => {
            const grids = items.values.map((val, y) => [
              x,
              y,
              this.aggregationValue({
                data: val,
                type: aggregation,
                aggregationNum: Number(aggregationNum),
              }),
            ]);

            nodes.push(...grids);
          });
          let buckets = [];
          if (resVal.buckets.length) {
            buckets = [
              resVal.buckets[0].min,
              ...resVal.buckets.map((item) => item.max),
            ];
          }

          this.chartSource = { nodes, buckets }; // nodes: number[][]
        }
        if (queryMetricType === QueryTypes.readMetricsTotalValue) {
          // this.chartSource = { nodes, buckets }; // nodes: number[][]
        }
        if (queryMetricType === QueryTypes.ReadMobileCustomMetricsValues) {
          if (resVal.length == 0) {
            this.chartSource[params.metricName] = [];
            return;
          }

          this.chartSource = {};
          if (chartType === 'ApexChartLine') {
            const { values } = resVal.values;

            this.chartSource[params.metricName] = values.map((item) =>
              this.aggregationValue({
                data: item,
                type: aggregation,
                aggregationNum: Number(aggregationNum),
              }),
            );
            let seriesKey = GetConstantValues.prototype.getValueByConstantName(
              params.metricName,
            );
            if (seriesKey) {
              this.chartSource[seriesKey] = this.chartSource[params.metricName];
              delete this.chartSource[params.metricName];
            }
          } else {
            const labels = (metricLabels || '')
              .split(',')
              .map((item) => item.replace(/^\s*|\s*$/g, ''));
            const indexList = (labelsIndex || '')
              .split(',')
              .map((item) => item.replace(/^\s*|\s*$/g, ''));
            for (const item of resVal) {
              if (item) {
                const list = item.values.values.map((d) =>
                  this.aggregationValue({
                    data: d,
                    type: aggregation,
                    aggregationNum: Number(aggregationNum),
                  }),
                );

                const indexNum = indexList.findIndex((d) => d === item.label);
                if (labels[indexNum] && indexNum > -1) {
                  this.chartSource[labels[indexNum]] = list;
                } else {
                  this.chartSource[item.label] = list;
                }
              }
            }
          }
        }
        if (queryMetricType === QueryTypes.ReadLabeledMetricsValues) {
          const labels = (metricLabels || '')
            .split(',')
            .map((item) => item.replace(/^\s*|\s*$/g, ''));
          const indexList = (labelsIndex || '')
            .split(',')
            .map((item) => item.replace(/^\s*|\s*$/g, ''));

          this.chartSource = {};
          for (const item of resVal || []) {
            const list = item.values.values.map((d) =>
              this.aggregationValue({
                data: d.value,
                type: aggregation,
                aggregationNum: Number(aggregationNum),
              }),
            );

            const indexNum = indexList.findIndex((d) => d === item.label);
            if (labels[indexNum] && indexNum > -1) {
              this.chartSource[labels[indexNum]] = list; // {[label: string]: number[]}
            } else {
              this.chartSource[item.label] = list;
            }
          }
        }
      }
      // this.loading = false;
    },
    childQueryValue(data, metricType) {
      for (const params of data) {
        const {
          queryMetricType,
          aggregation,
          aggregationNum,
          chartType,
          metricName,
        } = params.config;
        const resVal = params[queryMetricType];
        if (queryMetricType === QueryTypes.ReadMetricsValue) {
          if (chartType === 'ChartSlow') {
            // this.handleChartSlowData(
            //   resVal,
            //   aggregation,
            //   aggregationNum,
            //   metricName
            // );
          } else {
            const resArray = (resVal || []).map((item) => {
              return {
                name: item.name,
                avgNum: item.value,
                metricType: metricType,
              };
            });
            this.childSource.push(resArray[0] || []);
          }
        }

        if (queryMetricType === QueryTypes.ReadMetricsTotalValue) {
          const metricsValueTotal = {
            avgNum: resVal,
            name: metricName,
            metricType: metricType,
          };

          this.childSource.push(metricsValueTotal);
        }
      }
      // this.loading = false;
    },
    //type : { data: number; type: string; aggregationNum: string }
    formatDate(json) {
      let { aggregationNum } = json;
      if (!aggregationNum) {
        aggregationNum = 'YYYY-MM-DD HH:mm:ss';
      }
      if (json.type === CalculationType[4].value) {
        return dayjs(json.data).format(aggregationNum);
      } else if (json.type === CalculationType[5].value) {
        return dayjs.unix(json.data).format(aggregationNum);
      } else {
        return json.data;
      }
    },
    //type : { data: number; type: string; aggregationNum: number }
    aggregationValue(json) {
      if (isNaN(json.aggregationNum)) {
        return Math.round(json.data * 100) / 100;
      }
      if (json.type === CalculationType[0].value) {
        return Math.round((json.data + json.aggregationNum) * 100) / 100;
      }
      if (json.type === CalculationType[1].value) {
        return Math.round((json.data - json.aggregationNum) * 100) / 100;
      }
      if (json.type === CalculationType[2].value) {
        return Math.round(json.data * json.aggregationNum * 100) / 100;
      }
      if (json.type === CalculationType[3].value) {
        return Math.round((json.data / json.aggregationNum) * 100) / 100;
      }
      return Math.round(json.data * 100) / 100;
    },

    handleChartSlowData(resVal, aggregation, aggregationNum, metricName) {
      if (metricName === 'endpoint_slow_traces') {
        resVal = this.rocketData.slowTraces;
        this.showgraph = resVal.length ? true : false;
      }
      this.chartSource = (resVal || []).map((item) => {
        return {
          ...item,
          value: this.aggregationValue({
            data: item.value,
            type: aggregation,
            aggregationNum: Number(aggregationNum),
          }),
        };
      });
    },
  },
  created() {
    // this.itemConfig = this.chartConfig;
    // setTimeout(() => {
    //   this.chartRender();
    // }, 200);
  },
  watch: {
    updateDashboard(oldValue, newValue) {
      setTimeout(() => {
        this.chartRender();
      }, 300);
    },
    getDurationTime(oldValue, newValue) {
      setTimeout(() => {
        this.chartRender();
      }, 300);
    },
    // chartConfig(oldValue, newValue) {

    //      setTimeout(() => {
    //     this.chartRender();
    //   }, 300);
    // }
  },
  mounted() {
    this.itemConfig = this.chartConfig;
    setTimeout(() => {
      this.chartRender();
    }, 200);
  },
};
</script>
<style lang="scss" scoped>
.chart-box {
  width: 100%;
  height: 23.75em;
  @include dropshadow-effect;
  background-color: $bg-secondary;
  // border: 0.1px solid rgb(53, 64, 83);
  border-radius: 1.0625em;
}
</style>
